/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    import FlexEvent = Models.FlexEvent;
    import NetworkNode = Models.NetworkNode;
    import Block = Models.Block;

    export interface IIntervalEventLog {
        start: number;
        end: number;
    }

    interface IOffsettedRepo {
        idOffset: number;
        totalLoaded: number;
        pendingElements: number;
        firstLoadFinished: boolean;
        loading: boolean;
    }

    /**
     * Factory callback type
     */
    declare type EventLogDirectiveFactoryCb = (alarmsService: Services.AlarmsService,
                                                $window: ng.IWindowService,
                                                stompService: Services.StompService,
                                                $filter: Filters.ICustomFilters,
                                                timezoneService: Services.TimezoneService,
                                                $q: ng.IQService,
                                                blockService: Services.BlockService,
                                                networkNodeService: Services.NetworkNodeService,
                                                $timeout: ng.ITimeoutService) => EventLogDirective;

    /**
     * Custom scope
     */
    export interface IEventLogDirectiveScopeDef {
        interval: string;
        events: string;
    }

    /**
     * Custom attrs
     */
    export interface IEventLogDirectiveScope extends ng.IScope {
        interval: IIntervalEventLog;
        events: FlexEvent[];
        
        searchText: string;
        dateFrom: string;
        dateTo: string;
        timeFrom: string;
        timeTo: string;
        componentOperations: string[];
        componentOperationSelected: string;
        eventsRepo: IOffsettedRepo;
        search: () => void;
        clear: () => void;
        lastStartDate: number;
        lastEndDate: number;
    }

    export class EventLogDirective implements ng.IDirective {
        public static PAGE_SIZE: number = 1000;
        public static $name: string = "eventLog";
        
        public link: (scope: IEventLogDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public replace: boolean = true;
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/event-log-directive.html';
        public scope: IEventLogDirectiveScopeDef = {
            interval: '=',
            events: '=',
        };

        private nodes: { [key: string]: NetworkNode } = {};
        private blocks: { [key: string]: Block } = {};
        /*private fromDatePicker: UIkit.DatePicker;
        private toDatePicker: UIkit.DatePicker;*/
        private initialized: boolean;

        /**
         * Factory for the directive
         */
        public static Factory(): EventLogDirectiveFactoryCb {
            let directive: EventLogDirectiveFactoryCb = (alarmsService: Services.AlarmsService,
                                                         $window: ng.IWindowService,
                                                         stompService: Services.StompService,
                                                         $filter: Filters.ICustomFilters,
                                                         timezoneService: Services.TimezoneService,
                                                         $q: ng.IQService,
                                                         blockService: Services.BlockService,
                                                         networkNodeService: Services.NetworkNodeService,
                                                         $timeout: ng.ITimeoutService) => {
                return new EventLogDirective(alarmsService, $window, stompService, $filter,
                                            timezoneService, $q, blockService, networkNodeService,
                                            $timeout);
            };

            directive.$inject = ['alarmsService',
                                 '$window',
                                 'stompService',
                                 '$filter',
                                 'timezoneService',
                                 '$q',
                                 'blockService',
                                 'networkNodeService',
                                 '$timeout'];

            return directive;
        }

        /**
         * Constructor
         */
        constructor(alarmsService: Services.AlarmsService,
                    $window: ng.IWindowService,
                    stompService: Services.StompService,
                    $filter: Filters.ICustomFilters,
                    timezoneService: Services.TimezoneService,
                    $q: ng.IQService,
                    blockService: Services.BlockService,
                    networkNodeService: Services.NetworkNodeService,
                    $timeout: ng.ITimeoutService) {
            EventLogDirective.prototype.link = (scope: IEventLogDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                let tBodyPlaceholder: JQuery = $("#events_table tbody");
                /*let fromDatePlaceholder: JQuery = $('#from-date-picker');
                let toDatePlaceholder: JQuery = $('#to-date-picker');*/

                let eventDataPrettyPrint: (event: FlexEvent) => void = (event: FlexEvent) => {
                    let placeHolder: JQuery = $(`#event-${event.id}-info`);
                    let iconPlaceHolder: JQuery = $(`#event-${event.id}-icon`);
                    placeHolder.html(`<pre>${$filter('json')(event.data)}</pre>`);
                    let eventDetailsRow: JQuery = $(`#event-${event.id}-details`);
                    $(`#event-${event.id}-details-button`).bind('click', () => {
                        let currentDisplayValue: string = eventDetailsRow.css('display');
                        currentDisplayValue === 'none' ? 
                            eventDetailsRow.css('display', 'table-row') : eventDetailsRow.css('display', 'none');
                    });

                    // flexo events
                    if (event.component === Models.FLEXO_COMPONENT) {
                        if (event.operation === Models.TAKE_OPERATION) {
                            let sourceName: string = "Unknown";
                            let sinkName: string = "Unknown";
                            let sourceBlock: Block = this.blocks[event.data.source.toString()];
                            if (sourceBlock !== undefined) {
                                sourceName = sourceBlock.name;
                            }
                            let sinkBlock: Block = this.blocks[event.data.sink.toString()];
                            if (sinkBlock !== undefined) {
                                sinkName = sinkBlock.name;
                            }
                            placeHolder.html(`Connection made between <i>${sourceName}</i> and <i>${sinkName}</i>.`);
                            iconPlaceHolder.html('arrow_forward');
                        } else if (event.operation === Models.DROP_OPERATION) {
                            let sourceName: string = "Unknown";
                            let sinkName: string = "Unknown";
                            if (event.data && event.data.source) {
                                let sourceBlock: Block = this.blocks[event.data.source.toString()];
                                if (sourceBlock !== undefined) {
                                    sourceName = sourceBlock.name;
                                }
                            } else {
                                sourceName = "node " + event.data.streamPipe.sourceNodeHref;
                            }
                            let sinkBlock: Block = this.blocks[event.data.sink.toString()];
                            if (sinkBlock !== undefined) {
                                sinkName = sinkBlock.name;
                            }
                            placeHolder.html(`Connection dropped between <i>${sourceName}</i> and <i>${sinkName}</i>.`);
                            iconPlaceHolder.html('arrow_back');
                        } else if (event.operation === Models.CONFIRM_ALARM_OPERATION) {
                            placeHolder.html(`Confirmed alarm for <i>${event.data.deviceName}</i>.<br/>
                                            Parameter: ${event.data.name}. Reason: ${event.data.reason}.<br/>
                                            Comment: ${event.data.confirmComment === '' ? 'no comment' : event.data.confirmComment}`);
                            iconPlaceHolder.html('notifications_off');
                        } else if (event.operation === Models.QUICK_SETTINGS_OPERATION) {
                            let nodeName: string = "Unknown";
                            let node: NetworkNode = this.nodes[event.data.id];
                            if (node !== undefined) {
                                nodeName = node.name;
                            }
                            placeHolder.html(`<i>${nodeName}</i> settings changed from stream details view:
                                            ${event.data.optionDisplayname} set to ${event.data.valueDisplayName}.`);
                            iconPlaceHolder.html('settings');
                        } else if (event.operation === Models.QUICK_SETTINGS_EXTERNALLY_OPERATION) {
                            let nodeName: string = "Unknown";
                            let node: NetworkNode = this.nodes[event.data.id];
                            if (node !== undefined) {
                                nodeName = node.name;
                            }
                            placeHolder.html(`<i>${nodeName}</i> settings changed from external interface:
                                            ${event.data.optionDisplayname} set to ${event.data.valueDisplayName}.`);
                            iconPlaceHolder.html('settings');
                        } else if (event.operation === Models.QUICK_SETTINGS_REQUESTED_OPERATION) {
                            let nodeName: string = "Unknown";
                            let node: NetworkNode = this.nodes[event.data.id];
                            if (node !== undefined) {
                                nodeName = node.name;
                            }
                            placeHolder.html(`<i>${nodeName}</i> settings change requested:
                                            ${event.data.option} set to ${event.data.value}.`);
                            iconPlaceHolder.html('settings');
                        } else if (event.operation === Models.LOGIN_OPERATION) {
                            placeHolder.html(`User logged in.`);
                            iconPlaceHolder.html('person');
                        } else if (event.operation === Models.LOGOUT_OPERATION) {
                            placeHolder.html(`User logged out.`);
                            iconPlaceHolder.html('person');
                        } else if (event.operation === Models.LOGIN_FAILED_OPERATION) {
                            placeHolder.html(`Login failed: ${event.data.message} (Remote address: ${event.data.remoteAddress})`);
                            iconPlaceHolder.html('person_outline');
                        } else if (event.operation === Models.LOCKED_BLOCK_OPERATION) {
                            placeHolder.html(`<i>${event.data.name}</i> locked from Matrix room.<br/>
                                            Comment: ${!Common.Utils.exists(event.data.lockedComment) ? '<i>no comment</i>' :
                                                                                                        event.data.lockedComment}`);
                            iconPlaceHolder.html('lock_outline');
                        } else if (event.operation === Models.UNLOCKED_BLOCK_OPERATION) {
                            placeHolder.html(`<i>${event.data.name}</i> unlocked from Matrix room.<br/>`);
                            iconPlaceHolder.html('lock_open');
                        } else if (event.operation === Models.ADVANCED_SETTINGS_LOAD_OPERATION) {
                            let nodeName: string = "Unknown";
                            let node: NetworkNode = this.nodes[event.data.networkNodeHref];
                            if (node !== undefined) {
                                nodeName = node.name;
                            }
                            placeHolder.html(`User accessed advanced settings for <i>${nodeName}</i> from stream details view.`);
                            iconPlaceHolder.html('settings');
                        } else if (event.operation === Models.ADMIN_SETTINGS_LOAD_OPERATION) {
                            let nodeName: string = "Unknown";
                            let node: NetworkNode = this.nodes[event.data.networkNodeHref];
                            if (node !== undefined) {
                                nodeName = node.name;
                            }
                            placeHolder.html(`User accessed admin settings for <i>${nodeName}</i> from stream details view.`);
                            iconPlaceHolder.html('settings');
                        } else if (event.operation === Models.VIDEO_PLAY_OPERATION) {
                            let blockName: string = "Unknown";
                            let block: Block = this.blocks[event.data.blockId];
                            if (block !== undefined) {
                                blockName = block.name;
                            }
                            placeHolder.html(`Playing video stream from <i>${blockName}</i> (${event.data.videoUrl}).`);
                            iconPlaceHolder.html('play_arrow');
                        } else if (event.operation === Models.VIDEO_PLAY_ATTEMPT_OPERATION) {
                            let blockName: string = "Unknown";
                            let block: Block = this.blocks[event.data.blockId];
                            if (block !== undefined) {
                                blockName = block.name;
                            }
                            placeHolder.html(`Attempt to play video stream from <i>${blockName}</i> (${event.data.videoUrl}).`);
                            iconPlaceHolder.html('play_circle_filled');
                        } else if (event.operation === Models.VIDEO_PLAY_ERROR_OPERATION) {
                            let blockName: string = "Unknown";
                            let block: Block = this.blocks[event.data.blockId];
                            if (block !== undefined) {
                                blockName = block.name;
                            }
                            placeHolder.html(`Error playing video stream from <i>${blockName}</i> (${event.data.videoUrl}).`);
                            iconPlaceHolder.html('play_circle_outline');
                        }

                    // connRoom events
                    } else if (event.component === Models.CONNECTION_ROOM_COMPONENT) {
                        if (event.operation === Models.CREATE_MONITOR_OPERATION) {
                            placeHolder.html(`Created monitor "${event.data.name}" (id: ${event.data.id}).`);
                            iconPlaceHolder.html('tv');
                        } else if (event.operation === Models.DELETE_MONITOR_OPERATION) {
                            placeHolder.html(`Deleted monitor (id: ${event.data.id}).`);
                            iconPlaceHolder.html('tv').css('color', 'red');
                        } else if (event.operation === Models.SAVE_MONITOR_OPERATION) {
                            placeHolder.html(`Modified monitor "${event.data.name}" (id: ${event.data.id}).`);
                            iconPlaceHolder.html('tv');
                        } else if (event.operation === Models.TRENDING_ON_OPERATION) {
                            placeHolder.html(`Showing trending graph in monitor room "${event.data.name}"`);
                            iconPlaceHolder.html('show_chart');
                        } else if (event.operation === Models.TRENDING_OFF_OPERATION) {
                            placeHolder.html(`Hidding trending graph in monitor room "${event.data.name}"`);
                            iconPlaceHolder.html('show_chart');
                        }

                    // alarms events
                    } else if (event.component === Models.ALARMS_COMPONENT) {
                        let description: string;
                        if (event.operation === Models.BULK_CONFIRM_OPERATION) {
                            let srcNode: string = this.nodes[Common.Utils.strIdFromHref(event.data.destHref)].name;
                            let dstNode: string = this.nodes[Common.Utils.strIdFromHref(event.data.sourceHref)].name;
                            description = `Alarm bulk confirmation for nodes <i>${srcNode}</i> and ${dstNode}.`;
                            iconPlaceHolder.html('notifications_off');
                        } else if (event.operation === Models.BULK_CONFIRM_ALL_OPERATION) {
                            description = `Alarm bulk confirmation by admin.`;
                            iconPlaceHolder.html('notifications_off');
                        } else if (event.operation === Models.CREATE_ALARM_OPERATION) {
                            let alarmText: string = Models.Alarm.severityTexts[event.data.level];
                            let alarmTextColor: string = event.data.level === 0 || event.data.level === 8 ? 'white' : 'black';
                            let alarmBGColor: string = Models.Alarm.severityColors[event.data.level];
                            description = `
                                <span style="background-color: ${alarmBGColor}; color: ${alarmTextColor}" class="uk-badge">
                                    ${alarmText}
                                </span> `;
                            if (event.data.name === 'status') {
                                description += `<i>${event.data.deviceName}</i> went ${event.data.lastValue}.`;
                            } else if (event.data.name === 'inputErrorRate') {
                                description += `<i>${event.data.deviceName}</i> input IP error rate equals to ${event.data.lastValue}.`;
                            } else if (event.data.name === 'missingPackets') {
                                description += `<i>${event.data.deviceName}</i> number of missing input
                                                IP packets equals to ${event.data.lastValue}.`;
                            } else if (event.data.name === 'outputErrorRate') {
                                description += `<i>${event.data.deviceName}</i> ouput IP error rate equals to ${event.data.lastValue}.`;
                            } else if (event.data.name === 'jitter') {
                                description += `<i>${event.data.deviceName}</i> jitter equals to ${event.data.lastValue}.`;
                            } else if (event.data.name === 'bitrate') {
                                description += `<i>${event.data.deviceName}</i> TS input stream bitrate ${event.data.lastValue}.`;
                            } else if (event.data.name === 'streamStatus') {
                                description += `<i>${event.data.deviceName}</i> stream status went ${event.data.lastValue}.`;
                            } else if (event.data.name === 'tsLocked') {
                                description += `<i>${event.data.deviceName}</i> IP transport stream locked went ${event.data.lastValue}.`;
                            } else {
                                description += `<i>${event.data.deviceName}</i> ${event.data.name} (reason: ${event.data.reason}).`;
                            }
                            iconPlaceHolder.html('notifications');
                        }
                        placeHolder.html(description);

                    // networkNodes events
                    } else if (event.component === Models.NETWORK_NODES_COMPONENT) {
                        if (event.operation === Models.CREATE_NETWORK_NODE_OPERATION) {
                            placeHolder.html(`Created network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                        }  // support legacy create event operations
                        else if (event.operation === 'create' && event.data.elementClass === 'gateway') {
                            placeHolder.html(`Created gateway <i>${event.data.name}</i>.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                        } else if (event.operation === 'create' && event.data.elementClass === 'networkNode') {
                            placeHolder.html(`Created network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                        } else if (event.operation === Models.CREATE_GATEWAY_OPERATION) {
                            placeHolder.html(`Created gateway <i>${event.data.name}</i>.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                        } else if (event.operation === Models.CREATE_NETWORK_OPERATION) {
                            placeHolder.html(`Created network <i>${event.data.name}</i>.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-network');
                        } else if (event.operation === Models.DELETE_NETWORK_NODE_OPERATION) {
                            placeHolder.html(`Deleted network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                            iconPlaceHolder.removeClass('material-icon')
                                .addClass('eurovision-icon eurovision-node').css('color', 'red');                    
                        } else if (event.operation === Models.DELETE_GATEWAY_OPERATION) {
                            placeHolder.html(`Deleted gateway <i>${event.data.name}</i>.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway').css('color', 'red');
                        } // support legaccy delete event operations 
                        else if (event.operation === 'delete' && event.data.elementClass === 'gateway') {
                            placeHolder.html(`Deleted gateway <i>${event.data.name}</i>.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway').css('color', 'red');
                        } else if (event.operation === 'delete' && event.data.elementClass === 'networkNode') {
                            placeHolder.html(`Deleted network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node').css('color', 'red');
                        } else if (event.operation === Models.DELETE_NETWORK_OPERATION) {
                            placeHolder.html(`Deleted network <i>${event.data.name}</i>.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-network').css('color', 'red');
                        } else if (event.operation === Models.SAVE_NETWORK_NODE_OPERATION) {
                            placeHolder.html(`Network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}) ` + 
                                `has been modified.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-network');
                        } else if (event.operation === Models.SAVE_GATEWAY_OPERATION) {
                            placeHolder.html(`Gateway <i>${event.data.name}</i> has been modified.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                        }  // support legaccy save event operations
                        else if (event.operation === 'save' && event.data.elementClass === 'networkNode') {
                            placeHolder.html(`Network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}) ` + 
                                `has been modified.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                        } else if (event.operation === 'save' && event.data.elementClass === 'gateway') {
                            placeHolder.html(`Gateway <i>${event.data.name}</i> has been modified.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                        } else if (event.operation === 'save' && event.data.flexo === true) {
                            placeHolder.html(`FlexO has been modified.`);
                            iconPlaceHolder.html('warning');
                        } else if (event.operation === Models.SAVE_NETWORK_OPERATION) {
                            placeHolder.html(`Network <i>${event.data.name}</i> has been modified.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-network');
                        } else if (event.operation === Models.START_SUPPORT_TEST_OPERATION) {
                            let nodeName: string = "Unknown";
                            let node: NetworkNode = this.nodes[event.data.id];
                            if (node !== undefined) {
                                nodeName = node.name;
                            }
                            placeHolder.html(`Started support toolkit analysis for <i>${nodeName}</i>.`);
                            iconPlaceHolder.html('build');
                        } else if (event.operation === Models.END_SUPPORT_TEST_OPERATION) {
                            let nodeName: string = "Unknown";
                            let node: NetworkNode = this.nodes[event.data.id];
                            if (node !== undefined) {
                                nodeName = node.name;
                            }
                            $(`#event-${event.id}-details-button`).css('display', 'block');
                            $(`#event-${event.id}-details-content`).html(event.data.summary);
                            placeHolder.html(`Ended support toolkit analysis for <i>${nodeName}</i>.`);
                            iconPlaceHolder.html('build');
                        } else if (event.operation === Models.CREATE_LINK_OPERATION || event.operation === Models.DELETE_LINK_OPERATION) {
                            let srcName: string = event.data.networkElement.name;
                            let srcIp: string = event.data.networkInterface.ipAddress;
                            let dstName: string = event.data.networkInterface.networkConnectedTo.name;
                            let dstIp: string = event.data.networkInterface.networkConnectedTo.ipAddress;
                            let operation: string = event.operation === 'createdLink' ? 'created' : 'deleted';
                            placeHolder.html(`
                                Link ${operation} between <i>${srcName}</i>${srcIp !== '' ? ` (${srcIp})` : ''}
                                and <i>${dstName}</i>${dstIp !== '' ? ` (${dstIp})` : ''}.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-link');
                            if (event.operation === 'deletedLink') iconPlaceHolder.css('color', 'red');
                        } else if (event.operation === Models.WORKFLOW_CHANGED_OPERATION) {
                            placeHolder.html(`Network node <i>${event.data.name}</i> (S/N: ` + 
                                             `${event.data.mftSerialNumber}) set to workflow mode: ` + 
                                             `<b>${event.data.workflowMode}</b>`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                        } else if (event.operation === Models.DEVICE_CREDENTIALS_CHANGED) {
                            placeHolder.html(`Credentials changed for device ${event.data.deviceName}`);
                            iconPlaceHolder.html('lock').css('color', 'red');
                        } else if (event.operation === Models.SAVE_PROBE_OPERATION) {
                            placeHolder.html(`Probe <i>${event.data.name}</i> has been modified.`);
                            iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-radio-waves');
                        } else if (event.operation === Models.NETWORK_NODE_ORGANIZATION_CHANGED_OPERATION) {
                            placeHolder.html(`Organization ${event.data.name} has been changed.`);
                            iconPlaceHolder.html('person');
                        }

                    // watchdog events
                    } else if (event.component === Models.FLEXAUTH_COMPONENT) {
                        if (event.operation === Models.USER_CREATED_OPERATION) {
                            if (event.data.username !== undefined)
                                placeHolder.html(`User ${event.data.username} created by ${event.userId}.`);
                            else
                                placeHolder.html(`User created by ${event.userId}.`); 
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.USER_SAVED_OPERATION) {
                            if (event.data.toggled) {
                                if (event.data.enabled)
                                    placeHolder.html(`User ${event.data.username} enabled by ${event.userId}.`);
                                else
                                    placeHolder.html(`User ${event.data.username} disabled by ${event.userId}.`);
                            } else {
                                placeHolder.html(`User ${event.data.username} modified by ${event.userId}.`);
                            }
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.GROUP_CREATED_OPERATION) {
                            placeHolder.html(`Group ${event.data.groupname} created by ${event.userId}.`);
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.GROUP_SAVED_OPERATION) {
                            placeHolder.html(`Group ${event.data.groupname} modified by ${event.userId}.`);
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.USER_ADDED_TO_GROUP) {
                            placeHolder.html(`User ${event.data.username} added to group ${event.data.groupname} by ${event.userId}.`);
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.USER_REMOVED_FROM_GROUP) {
                            placeHolder.html(`User ${event.data.username} removed from group ${event.data.groupname} by ${event.userId}.`);
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.USER_ADDED_TO_ROLE) {
                            if (event.data.rolename !== undefined) {
                                placeHolder.html(`User ${event.data.username} added to role ${event.data.rolename} by ${event.userId}.`);
                                iconPlaceHolder.html('person');
                            }
                        }
                        if (event.operation === Models.USER_REMOVED_FROM_ROLE) {
                            placeHolder.html(`User ${event.data.username} removed from role ${event.data.rolename} by ${event.userId}.`);
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.OPERATION_CREATE_ORGANIZATION) {
                            placeHolder.html(`Organization ${event.data.name} created.`);
                            iconPlaceHolder.html('person');
                        }
                        if (event.operation === Models.OPERATION_DELETE_ORGANIZATION) {
                            placeHolder.html(`Organization ${event.data.name} deleted.`);
                            iconPlaceHolder.html('person');
                        }
                    }
                };

                let drawEvent: (event: FlexEvent) => void = (event: FlexEvent) => {
                    let userName: string = event.userId;
                    if (event.userId === 'demiurgo') {
                        userName = '<i>system<i>';
                    } else if (event.userId === 'unknown') {
                        userName = '<i>unknown</i>';
                    }
                    let idAlreadyExists: boolean = $(`#event-${event.id}-info`).length > 0 ? true : false;
                    if (!idAlreadyExists) {
                        let newRow: string = 
                            `<tr>
                                <td>
                                    ${$filter('timezone')(new Date(event.timestamp),
                                                          'D-MM-YYYY HH:mm:ss', timezoneService.getEffectiveTimezone())}
                                </td>
                                <td>${userName}</td>
                                <td>${Services.ComponentOperationService.getTypeFromComponentOperation(event.component, event.operation)}
                                </td>
                                <td><i id="event-${event.id}-icon" class="material-icons"></i></td>
                                <td id="event-${event.id}-info"></td>
                                <td>
                                    <i id="event-${event.id}-details-button" class="event-to-unbind" data-uk-tooltip tooltip="Details"
                                    class="material-icons uk-text-muted" style="cursor: pointer; display: none;">
                                        info
                                    </i>
                                </td>
                            </tr>
                            <tr id="event-${event.id}-details" class="uk-text-muted" style="display: none;">
                                <td colspan="7"><pre style="max-width: 600px; float: right;" id="event-${event.id}-details-content"></td>
                            </tr>`;
                        tBodyPlaceholder.append(newRow);
                        eventDataPrettyPrint(event);
                    }
                };

                let loadEvents: (events: FlexEvent[]) => void = (events: FlexEvent[]) => {
                    scope.eventsRepo.idOffset = events.length > 0 ? events[events.length - 1].id : 0;
                    scope.eventsRepo.totalLoaded = scope.eventsRepo.totalLoaded + events.length;
                    scope.eventsRepo.pendingElements = scope.eventsRepo.pendingElements - events.length;
                    events.forEach((event: FlexEvent) => {
                        drawEvent(event);
                    });
                };

                let drawNotDataFound: () => void  = () => {
                    let newRow: string =
                        `<tr class="uk-text-center uk-text-muted">
                            <td colspan="7"><i>No results found</i></td>
                        </tr>`;
                    tBodyPlaceholder.append(newRow);
                };

                let init: () => ng.IPromise<void> = () => {
                    $timeout(() => {
                        window.altair_admin_common_init();
                    }, 500);
                    scope.componentOperations = Services.ComponentOperationService.getAvailableTypes().sort();
                    scope.componentOperations.unshift('All');
                    scope.componentOperationSelected = 'All';
                    scope.searchText = "";
                    scope.eventsRepo = {
                        idOffset: undefined,
                        totalLoaded: 0,
                        pendingElements: 0,
                        firstLoadFinished: false,
                        loading: true,
                    };
                    
                    return $q.all([
                            networkNodeService.getAllNetworkNodesPromise(),
                            blockService.getAllBlocksPromise(),
                        ])
                        .then((res: [NetworkNode[], Block[]]) => {
                            // mapping nodes
                            for (let node of res[0])
                                this.nodes[Common.Utils.strIdFromHref(node.href)] = node;

                            // mapping blocks
                            for (let block of res[1])
                                this.blocks[Common.Utils.strIdFromHref(block.href)] = block;

                            // drawing more events on scroll
                            // launchScrollEvent();
                        });
                    // loadDatePickers();
                };

                let eventsFormFilter: (event: FlexEvent) => boolean = (event: FlexEvent) => {
                    let co: Models.ComponentOperation =
                                    Services.ComponentOperationService.getComponentOperationFromType(scope.componentOperationSelected);
                    return (co.component === undefined || event.component === co.component)
                           && (co.operation === undefined || co.operation === event.operation)
                           && (scope.searchText === "" || event.userId.indexOf(scope.searchText) !== -1)
                           && new Date(event.timestamp.toString()).getTime() <= scope.interval.end
                           && new Date(event.timestamp.toString()).getTime() >= scope.interval.start;
                };

                let unbindEvents: () => void = () => {
                    let eventsToUnbind: JQuery = $('.event-to-unbind');
                    if (eventsToUnbind.length > 0) {
                        eventsToUnbind.unbind('click');
                    }
                };

                let cleanAndDraw: () => void = () => {
                    scope.eventsRepo.firstLoadFinished = false;
                    let eventsList: FlexEvent[] = scope.events.filter(eventsFormFilter);
                    unbindEvents();
                    tBodyPlaceholder.empty();
                    if (eventsList && eventsList.length === 0) {
                        drawNotDataFound();
                    } else {
                        scope.eventsRepo.pendingElements = 0;
                        loadEvents(eventsList);
                    }
                    scope.eventsRepo.firstLoadFinished = true;
                    scope.eventsRepo.loading = false;
                };

                scope.search = () => {
                    // getDatesFromPicker();
                    if (scope.events !== undefined) {
                        scope.eventsRepo.firstLoadFinished = false;
                        scope.eventsRepo.loading = true;
                    }
                    cleanAndDraw();
                };

                scope.clear = () => {
                    scope.searchText = "";
                    scope.dateFrom = undefined;
                    scope.dateTo = undefined;
                    scope.timeFrom = undefined;
                    scope.timeTo = undefined;
                    scope.componentOperationSelected = 'All';
                    scope.search();
                };

                scope.$watch('searchText', (newVal: string, oldVal: string) => {
                    if (newVal !== undefined && oldVal !== undefined && newVal !== oldVal) {
                        cleanAndDraw();
                    }
                });

                scope.$watch('componentOperationSelected', (newVal: string, oldVal: string) => {
                    if (newVal !== undefined && oldVal !== undefined && newVal !== oldVal) {
                        cleanAndDraw();
                    }
                });

                scope.$watch('interval', (newValue: IIntervalEventLog, oldValue: IIntervalEventLog) => {
                    if (this.initialized && newValue.start && newValue.end) {
                        cleanAndDraw();
                    }
                }, true);

                scope.$watch('events', (newValue: FlexEvent[], oldValue: FlexEvent[]) => {
                    if (this.initialized && scope.interval.start && scope.interval.end) {
                        cleanAndDraw();
                    }
                }, true);

                scope.$on('$destroy', () => {
                    unbindEvents();
                });
                
                init().then(() => {
                    this.initialized = true;
                    scope.search();
                });
            };
        }
    }
}
